<template>
  <div>
    <b-modal ref="sellerSelectModel" size="lg" title="インボイス構成商品情報" hide-footer=true>
      <!-- <b-row>
        <b-col sm="3">
          <h5>{{ dispProductCount }}</h5>
        </b-col>
        <b-col sm="1" class="text-right">
          <b-img class="image-sm" :src="item.productImageUrl"></b-img>
        </b-col>
        <b-col sm="8" class="text-left">
          <h6>{{ dispProductInfo }}</h6>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col sm="12">
          <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                  :items="items" :fields="fields"
                  :current-page="currentPage" :per-page="perPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                  :filter="filter" @filtered="onFiltered">
          <!-- <template slot="productCondition" slot-scope="row">
            <div><label>{{conditionTypes(row.value)}}</label></div>
          </template> -->
          <template slot="productName" slot-scope="row">
            <div>{{row.item['productName']}}</div>
            <div>(SKU:{{row.item['sku']}})</div>
          </template>
          <template slot="amount" slot-scope="row">
            <div><label>{{formatPrice(row.item['amount'])}}</label></div>
          </template>
          <template slot="includeLithiumBattery" slot-scope="row">
            <b-checkbox size="sm" v-model="row.value" disabled></b-checkbox>
          </template>
          <template slot="productImageUrl" slot-scope="row"><b-img class="image" :src="row.value"></b-img></template>
          <template slot="status" slot-scope="row">
            <div v-for='(value, index) in row.item.statusMessage' :key='index'>
              {{ value }}
            </div>
          </template>
          <template slot="category" slot-scope="row">
            <div><label class="mark bkcolor-red">英</label> {{row.item['dcategoryName']}}</div>
            <div v-if="!row.item['isComplete']"><label class="mark bkcolor-darkblue">日</label> {{row.item['dcategoryNameJp']}}</div>
            <div v-if="!row.item['isComplete']"><label class="mark bkcolor-blue">参考：<span>{{row.item['categoryNameAmazon']}}</label></div>
          </template>
          <template slot="makerAddress" slot-scope="row">
            <div>{{row.item['makerAddress']}}</div>
            <div><label class="mark bkcolor-blue">参考：<span>{{row.item['brand']}}</label></div>
          </template>
          <template slot="form" slot-scope="row">
            <div><label>{{row.item['dformMainName']}}</label></div>
            <div v-if="!row.item['isComplete']"><label class="mark bkcolor-red">自</label>{{row.item['dformAutoName']}}</div>
            <div v-if="!row.item['isComplete']"><label class="mark bkcolor-darkblue">手</label>{{row.item['dformManualName']}}</div>
            <div v-if="!row.item['isComplete'] && row.item['unavailableFormAuto']"><label class="mark bkcolor-dark">※自動無効</label></div>
          </template>
          <template slot="material" slot-scope="row">
            <div><label>{{row.item['dmaterialMainName']}}</label></div>
            <div v-if="!row.item['isComplete']"><label class="mark bkcolor-red">自</label>{{row.item['dmaterialAutoName']}}</div>
            <div v-if="!row.item['isComplete']"><label class="mark bkcolor-darkblue">手</label>{{row.item['dmaterialManualName']}}</div>
          </template>
          <template slot="update" slot-scope="row">
            <b-button size="sm" @click="editModal(row)" :disabled="row.item['isComplete']" variant="warning">更新</b-button>
          </template>
          </b-table>
          <!-- <b-col md="6">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col> -->
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="confirmMessage" ok-only hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="registerMakerMaster" title="メーカーマスタ登録" @ok="registerMakerMaster">
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="メーカー名" label-for="newMakerName">
        <b-form-input size="sm" id="newMakerName" v-model="newMakerName" type="text"/>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="住所" label-for="newMakerAddress">
        <b-form-input size="sm" id="newMakerAddress" v-model="newMakerAddress" type="text"/>
    </b-modal>
    <b-modal ref="editModal" title="データベース登録" @ok="handleOk">
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="ASIN" label-for="asin">
        <b-form-input size="sm" id="asin" v-model="editItem.asin" disabled type="text"/>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="登録日" label-for="registeredDate">
        <b-form-input size="sm" id="registeredDate" v-model="editItem.registeredDate" type="text"/>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="カテゴリ" label-for="categoryName">
        <category-search :categoryName="editItem.dcategoryName" :categoryWarningMessage="editItem.categoryWarningMessage" @selectedCategory="($event) => editItem.categoryId=$event" @selectedCategoryName="($event) => editItem.dcategoryName=$event" />
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="商品名" label-for="productNameOrg">
        <b-form-input size="sm" id="productNameOrg" v-model="editItem.productNameOrg" type="text"/>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="リチウム" label-for="makerAddrCity">
        <b-checkbox size="sm" class="check-mark" v-model="editItem.includeLithiumBattery"></b-checkbox>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="フォーム(自)無効" label-for="unavailableFormAuto">
        <b-checkbox size="sm" class="check-mark" v-model="editItem.unavailableFormAuto"></b-checkbox>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="フォーム(手)" label-for="formManual">
        <b-form-select size="sm" id="formManual" v-model="editItem.formIdManual" :options="invoiceFormTypes"/>
      </b-form-group>
      <!-- <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="材料(手)" label-for="materialManual">
        <b-form-select size="sm" id="materialManual" v-model="editItem.materialManual" :options="invoiceMaterialTypes"/>
      </b-form-group> -->
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="材質(手)" label-for="materialName">
        <material-search :materialName="editItem.dmaterialManualName" @selectedMaterial="($event) => editItem.materialManual=$event" @selectedMaterialName="($event) => editItem.dMaterialManualName=$event" />
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="メーカー" label-for="maker">
        <maker-search :makerName="editItem.dmakerName" :makerAddress="editItem.makerAddress" :dispAddress="true" :dispRegistButton="true" @registerMakerButton="dispMakerPopup()" @selectedMaker="($event) => editItem.makerId=$event" @selectedMakerName="($event) => editItem.dmakerName=$event" @selectedMakerAddress="($event) => editItem.makerAddress=$event"/>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import * as utility from '@/utility';
import BaseComponent from '@/components/BaseComponent';
import ConditionType from '@/types/ConditionType';
import SearchCategory from '@/components/invoice/SearchCategory';
import SearchMaker from '@/components/invoice/SearchMaker';
import SearchMaterial from '@/components/invoice/SearchMaterial';
import InvoiceFormType from '@/types/InvoiceFormType';
import InvoiceMaterialType from '@/types/InvoiceMaterialType';
import * as api from '@/api';

export default {
  mixins: [BaseComponent],
  props: {
    // item: {
    //   default: [],
    // }
  },
  computed: {
    dispProductCount() {
      return '[ 表示 ] ' + this.totalRows + '件　　';
    },
    dispProductInfo() {
      return '[ ASIN ] ' + this.item.asin + '　 [商品名] ' + this.item.productNameEn;
    },
  },
  data() {
    return {
      items: [],
      item: [],
      editItem: {},
      fields: [
        { key: 'asin',     label: 'ASIN', sortable: true, variant: 'base', class: 'table-lw7'},
        // { key: 'sku', label: 'SKU', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'productImageUrl', label: '画像', sortable: true, variant: 'base', class: 'table-cw4' },
        { key: 'productName', label: '商品名', sortable: true, variant: 'base', class: 'table-lw16' },
        { key: 'category', label: 'カテゴリ', sortable: true, variant: 'base', class: 'table-lw16' },
        { key: 'form', label: 'フォーム', sortable: true, variant: 'base', class: 'table-lw7' },
        { key: 'material', label: '材料', sortable: true, variant: 'base', class: 'table-lw9' },
        { key: 'makerAddress', label: 'メーカー', sortable: true, variant: 'base'},
        { key: 'includeLithiumBattery', label: 'リチ', sortable: true, variant: 'base', class: 'table-cw4' },
        { key: 'shippingQuantity',label: '購入数', sortable: true, variant: 'warning', class: 'table-rw5' },
        { key: 'amount', label: '総額', sortable: true, variant: 'warning', class: 'table-rw7' },
        { key: 'status', label: 'status', sortable: true, variant: 'base', class: 'table-lw12' },
        { key: 'update',   label: '更新',   sortable: true, variant: 'success', class: 'table-cw4' },
      ],
      currentPage: 1,
      perPage: 100,
      totalRows: 0,
      pageOptions: [ 25, 50, 100 ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      activate: false,
      modalInfo: { title: '', content: '' },
      sizeTypeFilter: null,
      productStatusFilter: '1',
      conditionTypes: ConditionType.getConditionText,
      member_id: '',
      member_name: '',
      fbaNumberFilter: '',
      jan_code: '',
      name_filter: '',
      size_filter: '1',
      status_filter: '1',
      not_inbound_flag: true,
      editRowKey: null,
      selectedRowItem: {},
      modalInfo: { title: '', content: '' },
      confirmMessage: '',
      newMakerName: '',
      newMakerAddress: '',
      invoiceFormTypes: InvoiceFormType.values(),
      invoiceMaterialTypes: InvoiceMaterialType.values()
    };
  },
  methods: {
    editModal(row) {
      this.editItem = {};
      if (row !== null) {
        this.editItem =  Object.assign({}, this.editItem , row.item);
      }
      this.$refs.editModal.show();
    },
    handleOk() {
      api.updateInvoiceProductMaster(this.fbaNumberFilter, null, null, null, null, null, null, this.editItem, (data) => {
        this.items = data.productMasterList;
        this.addCellVariantDetail(this.items);
        this.confirmMessage = '登録完了しました。';
        this.$refs.confirmMessage.show();
      });
    },
    dispMakerPopup(){
      this.newMakerName = '';
      this.newMakerAddress = '';
      this.$refs.registerMakerMaster.show();
    },
    registerMakerMaster(){
      api.registerMakerMasterInInvoiceProduct(this.newMakerName, this.newMakerAddress, (data) => {
        this.$refs.registerMakerMaster.hide();
        this.editItem.makerId = data.makerId;
        this.editItem.dmakerName = data.makerName;
        this.editItem.makerAddress = data.makerAddress;
      });
    },
    formatDate(value) {
      return utility.formatDate(value);
    },
    showModal(data) {
      this.fbaNumberFilter = data.fbaNumber;
      this.items = data.productMasterList;
      this.addCellVariantDetail(this.items);
      this.$refs.sellerSelectModel.show();
    },
    hideModal() {
      this.$refs.sellerSelectModel.hide();
    },
    addCellVariantDetail(items) {
      for (const v of items) {
        const errorCells = [];
        if (v['isErrorCategory']) {
          errorCells['category'] = 'danger';
          errorCells['material'] = 'danger';
          errorCells['status'] = 'danger';
        }
        if (v['isErrorMaker']) {
          errorCells['maker'] = 'danger';
          errorCells['status'] = 'danger';
        }
        if (v['isErrorMaterial']) {
          errorCells['material'] = 'danger';
          errorCells['status'] = 'danger';
        }
        // if (v['includeLithiumBattery']) {
        //   v['includeLithiumBattery'] = '●';
        // } else{
        //   v['includeLithiumBattery'] = '-';
        // }
        v['_cellVariants'] = errorCells;
      }
    },
  },
};

Vue.component('category-search', SearchCategory);
Vue.component('maker-search', SearchMaker);
Vue.component('material-search', SearchMaterial);

</script>

<style>
.margin-left {
  margin-left: 1rem;
}
.margin-top {
  margin-top: 1rem;
}
.image-sm {
  align-content: left;
  height: 1.5rem;
  width: 1.5rem; 
}
.modal-lg {
  max-width: 2000px!important;
}
.mark {
    border-radius: 0.5rem;
    font-size: 0.8rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
}
.bkcolor-red{
    background-color: red;
    color: white;
}
.bkcolor-yellow{
    background-color: yellow;
    color: black;
}
.bkcolor-orange{
    background-color: lightsalmon;
    color: black;
}
.bkcolor-green{
    background-color: lightgreen;
    color: black;
}
.bkcolor-blue{
    background-color: skyblue;
    color: black;
}
.bkcolor-dark{
    background-color: darkgray;
    color: black;
}
.bkcolor-darkblue{
    background-color: blue;
    color: white;
}

@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
}
</style>

